// Store all swiper instances
window.swiperInstances = window.swiperInstances || {};

// ============================================
// Media Control Functions
// ============================================

window.pauseAllMedia = function () {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
};

window.playMediaInSlide = function (slide) {
  if (!slide) return;
  
  const youtubeVideo = slide.querySelector('.js-youtube');
  if (youtubeVideo) {
    youtubeVideo.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*');
    youtubeVideo.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
  }
  
  const vimeoVideo = slide.querySelector('.js-vimeo');
  if (vimeoVideo) {
    vimeoVideo.contentWindow.postMessage('{"method":"setVolume","value":0}', '*');
    vimeoVideo.contentWindow.postMessage('{"method":"play"}', '*');
  }
  
  const nativeVideo = slide.querySelector('video');
  if (nativeVideo) {
    nativeVideo.play().catch(err => console.log('Auto-play prevented:', err));
  }
  
  const model = slide.querySelector('product-model');
  if (model && model.modelViewerUI) {
    model.modelViewerUI.play();
  }
};

window.pauseMediaInSlide = function (slide) {
  if (!slide) return;
  
  const youtubeVideo = slide.querySelector('.js-youtube');
  if (youtubeVideo) {
    youtubeVideo.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  }
  
  const vimeoVideo = slide.querySelector('.js-vimeo');
  if (vimeoVideo) {
    vimeoVideo.contentWindow.postMessage('{"method":"pause"}', '*');
  }
  
  const nativeVideo = slide.querySelector('video');
  if (nativeVideo) {
    nativeVideo.pause();
  }
  
  const model = slide.querySelector('product-model');
  if (model && model.modelViewerUI) {
    model.modelViewerUI.pause();
  }
};

// ============================================
// Play/Pause Button Functions
// ============================================

window.updatePlayPauseButton = function(slide) {
  if (!slide) return;
  
  const button = slide.querySelector('.video-play-pause');
  if (!button) return;
  
  const hasVideo = slide.getAttribute('data-has-video') === 'true';
  
  if (hasVideo) {
    button.style.display = 'block';
    button.setAttribute('data-state', 'playing');
    button.setAttribute('aria-label', 'Pause video');
    const pauseIcon = button.querySelector('.pause-icon');
    const playIcon = button.querySelector('.play-icon');
    if (pauseIcon) pauseIcon.style.display = 'block';
    if (playIcon) playIcon.style.display = 'none';
  } else {
    button.style.display = 'none';
  }
};

window.toggleVideoPlayback = function(slide, button) {
  if (!slide || !button) return;
  
  const currentState = button.getAttribute('data-state');
  const pauseIcon = button.querySelector('.pause-icon');
  const playIcon = button.querySelector('.play-icon');
  
  if (currentState === 'playing') {
    window.pauseMediaInSlide(slide);
    button.setAttribute('data-state', 'paused');
    button.setAttribute('aria-label', 'Play video');
    if (pauseIcon) pauseIcon.style.display = 'none';
    if (playIcon) playIcon.style.display = 'block';
  } else {
    window.playMediaInSlide(slide);
    button.setAttribute('data-state', 'playing');
    button.setAttribute('aria-label', 'Pause video');
    if (pauseIcon) pauseIcon.style.display = 'block';
    if (playIcon) playIcon.style.display = 'none';
  }
};

// ============================================
// Core Swiper Management
// ============================================

/**
 * Initialize a swiper with tracking
 * @param {string} selector - CSS selector for swiper element
 * @param {Object} options - Swiper configuration options
 * @param {string} name - Optional unique name (auto-generated if not provided)
 * @returns {Object|null} Swiper instance or null
 */
function initSwiper(selector, options = {}, name = null) {
  const element = document.querySelector(selector);
  if (!element) {
    console.warn(`Swiper element not found: ${selector}`);
    return null;
  }
  
  if (!name) {
    name = selector.replace(/[.\s#]/g, '-').replace(/^-+|-+$/g, '');
  }
  
  if (window.swiperInstances[name]) {
    console.log(`Destroying existing swiper: ${name}`);
    window.swiperInstances[name].destroy(true, true);
  }
  
  const swiper = new Swiper(selector, options);
  
  window.swiperInstances[name] = swiper;
  swiper._swiperName = name;
  swiper._swiperSelector = selector;
  
  // console.log(`Swiper initialized: ${name}`);  
  return swiper;
}

/**
 * Get swiper instance by name
 * @param {string} name - Swiper name
 * @returns {Object|null} Swiper instance or null
 */
function getSwiper(name) {
  return window.swiperInstances[name] || null;
}

/**
 * Get swiper instance from element
 * @param {HTMLElement} element - Any element inside swiper
 * @returns {Object|null} Swiper instance or null
 */
function getSwiperFromElement(element) {
  const swiperContainer = element.closest('.swiper');
  if (!swiperContainer) return null;
  
  return Object.values(window.swiperInstances).find(
    swiper => swiper && swiper.el === swiperContainer
  ) || null;
}

/**
 * Destroy swiper instance by name
 * @param {string} name - Swiper name
 */
function destroySwiper(name) {
  if (window.swiperInstances[name]) {
    console.log(`Destroying swiper: ${name}`);
    window.swiperInstances[name].destroy(true, true);
    delete window.swiperInstances[name];
  }
}

/**
 * Destroy all swipers matching a pattern
 * @param {string} pattern - Pattern to match (e.g., section ID)
 */
function destroySwipersByPattern(pattern) {
  Object.keys(window.swiperInstances).forEach(name => {
    if (name.includes(pattern)) {
      console.log(`Destroying swiper matching pattern ${pattern}: ${name}`);
      window.swiperInstances[name].destroy(true, true);
      delete window.swiperInstances[name];
    }
  });
}

/**
 * Destroy all swipers in a section (for theme editor)
 * @param {string} sectionId - Section ID from Shopify
 */
function destroySectionSwipers(sectionId) {
  destroySwipersByPattern(sectionId);
}

function getAllSwipers() {
  return window.swiperInstances;
}

// ============================================
// Export Functions
// ============================================
window.initSwiper = initSwiper;
window.getSwiper = getSwiper;
window.getSwiperFromElement = getSwiperFromElement;
window.destroySwiper = destroySwiper;
window.destroySwipersByPattern = destroySwipersByPattern;
window.destroySectionSwipers = destroySectionSwipers;
window.getAllSwipers = getAllSwipers;